import { PanoramaImages } from '../dtos/panoramaImages';
import { HotSpot } from '../dtos/hotSpot';
import { MonumentDto } from '../dtos/monumentDto';

export class SharedVo {
    selectedPanorama: PanoramaImages;
    sitePanoramicHotspots: HotSpot[];
    selectedMonument: MonumentDto;
    fileToShare: string;
    monumentView: any;
    isMonumentOpen: boolean;
}